import React, { FC, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout } from 'antd';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { EditPage } from '../edit_page/EditPage';
import { equipmentPerStockLocationsRestCrudThunksForSupplier } from '../../thunks/equipment_per_stock_locations_thunks';
import AddOrEditEquipmentPerStockLocationForm from '../add_or_edit_equipment_per_stocklocation_form/AddOrEditEquipmentPerStockLocationForm';

const { Content } = Layout;

const EditEquipmentPerStockLocationPage: FC<any> = ({
	history,
	match,
	getEpsl,
	fetching,
	epsl,
}): React.ReactElement => {
	const epslId = useMemo(() => match.params.id, [match.params.id]);

	useEffect(() => {
		epslId && getEpsl(epslId);
	}, [getEpsl, epslId]);

	return (
		<Content>
			<EditPage
				title="Edit Equipment"
				formComponentProps={{
					formData: epsl,
					stockLocationId: nullSafeGet('stockLocationId', epsl),
					onSuccess: (rec) => history.goBack(),
				}}
				fetching={fetching}
				FormComponent={AddOrEditEquipmentPerStockLocationForm}
			/>
		</Content>
	);
};

const mapStateToProps = (state) => {
	return {
		fetching: state.equipment_per_stock_locations.fetching,
		epsl: state.equipment_per_stock_locations.detail,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getEpsl: (id) => dispatch(equipmentPerStockLocationsRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(EditEquipmentPerStockLocationPage)
);
